export function FlipBackward() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M2.5 7.49996H13.75C15.8211 7.49996 17.5 9.17889 17.5 11.25C17.5 13.321 15.8211 15 13.75 15H10M2.5 7.49996L5.83333 4.16663M2.5 7.49996L5.83333 10.8333"
        stroke="#344054"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
